import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FundsListComponent} from "./funds-list.component";
import {MatButtonModule} from "@angular/material/button";
import {MatTableModule} from "@angular/material/table";
import {MatSortModule} from "@angular/material/sort";
import {MatPaginatorModule} from "@angular/material/paginator";
import { AddFundComponent } from './add-fund/add-fund.component';
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatSelectModule } from "@angular/material/select";
import { MatIconModule } from "@angular/material/icon";
import { AddCertificatedOutletComponent } from './add-certificated-outlet/add-certificated-outlet.component';
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { FundComponent } from './fund/fund.component';
import { FundInformationComponent } from './fund/fund-subcomponents/fund-information/fund-information.component';
import {MatCardModule} from "@angular/material/card";
import { FundParticipantsComponent } from './fund/fund-subcomponents/fund-participants/fund-participants.component';
import { FundInvestorsComponent } from './fund/fund-subcomponents/fund-investors/fund-investors.component';
import { FundCreditsTableComponent } from './fund/fund-subcomponents/fund-credits-table/fund-credits-table.component';
import { FundBudgetedRevenueComponent } from './fund/fund-subcomponents/fund-budgeted-revenue/fund-budgeted-revenue.component';
import { FundPageButtonsComponent } from './fund/fund-subcomponents/fund-page-buttons/fund-page-buttons.component';
import {SharedModule} from "../components/shared.module";
import {FundRoutingModule} from "./fund-routing.module";
import {MatExpansionModule} from "@angular/material/expansion";
import { ReviewTimelineComponent } from './review-timeline/review-timeline.component';
import { TimelineTrackerSectionComponent } from './review-timeline/timeline-tracker-section/timeline-tracker-section.component';
import { MatTooltipModule } from "@angular/material/tooltip";
import {MatDividerModule} from "@angular/material/divider";
import {MatRadioModule} from "@angular/material/radio";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import { AddProjectCreditComponent } from './add-project-credit/add-project-credit.component';
import {MatCheckboxModule} from "@angular/material/checkbox";
import { PipesModule } from "../pipes/pipes.module";




@NgModule({
  declarations: [
    FundsListComponent,
    AddFundComponent,
    AddCertificatedOutletComponent,
    FundComponent,
    FundInformationComponent,
    FundParticipantsComponent,
    FundInvestorsComponent,
    FundCreditsTableComponent,
    FundBudgetedRevenueComponent,
    FundPageButtonsComponent,
    ReviewTimelineComponent,
    TimelineTrackerSectionComponent,
    AddProjectCreditComponent
  ],

    imports: [
        CommonModule,
        MatButtonModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        MatDialogModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatInputModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatIconModule,
        MatAutocompleteModule,
        MatProgressSpinnerModule,
        MatCardModule,
        FundRoutingModule,
        SharedModule,
        MatExpansionModule,
        FormsModule,
        MatTooltipModule,
        MatDividerModule,
        MatRadioModule,
        MatButtonToggleModule,
        MatCheckboxModule,
        PipesModule
    ]
})
export class FundsModule { }
